import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Header from '../Header/Header';
import { DotLoader } from 'react-spinners';
import WelcomeBanner from './WelcomeBanner';
import AdminSidebar from './AdminSidebar';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/* Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main className="grow">
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Welcome banner */}
            <WelcomeBanner />

            <div className="bg-white dark:bg-slate-800 shadow-lg rounded-2xl mb-8">
              <div className="flex flex-col md:flex-row md:-mr-px">
                <AdminSidebar />
                
                {/* Main content area */}
                <div className="flex-1 md:ml-0">
                  <div className="h-full">
                    <Outlet context={{ setIsLoading, isLoading }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Loading overlay */}
      {isLoading && (
        <div className="absolute w-screen h-screen z-60 flex justify-center items-center bg-black bg-opacity-50">
          <DotLoader size={80} color="#6076E7" />
        </div>
      )}
    </div>
  );
};

export default AdminLayout; 